import React, { CSSProperties, ReactNode, useEffect, useLayoutEffect, useRef } from "react";

interface IProps {
	children: ReactNode
	className?: string
	updateWidth?: (width: number) => void
	updateHeight?: (height: number) => void
	style?: CSSProperties ,
}

export const Measured : React.FC<IProps> = ({children, className, style, updateWidth, updateHeight}) => {
	const ref = useRef<HTMLDivElement>(null);

	const element = ref.current;
	useEffect(() => {
		if(element) {
			const observer = new ResizeObserver((entries) => {
				updateWidth?.(entries[0].contentRect.width)
				updateHeight?.(entries[0].contentRect.height)
			});
			
			observer.observe(element);

			return () => observer.disconnect()
		}
		return
	}, [element, updateHeight, updateWidth])

	useLayoutEffect(() => {
		const rect = ref.current?.getBoundingClientRect()
		if(rect) {
			updateWidth?.(rect.width)
			updateHeight?.(rect.height)
		}
	}, [updateWidth, updateHeight])

	return <div className={className} ref={ref} style={style}>{children}</div>
}